<template>
  <v-container>
    <v-card class="elevation-5 rounded-lg overflow-hidden">
      <v-toolbar dark color="primary" flat>
        <v-icon left>mdi-format-list-bulleted-type</v-icon>
        <v-toolbar-title class="font-weight-bold">
          {{ $t('activities') }}
        </v-toolbar-title>
      </v-toolbar>

      <v-tabs v-model="activeTab" background-color="primary" dark slider-color="white" centered grow>
        <v-tab class="font-weight-bold">
          <v-icon left>mdi-database</v-icon>
          {{ $t('base_activities') }}
        </v-tab>
        <v-tab class="font-weight-bold">
          <v-icon left>mdi-star-circle</v-icon>
          {{ $t('extracurricular_activities') }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="activeTab">
        <!-- TAB 1: ACTIVIDADES BASE -->
        <v-tab-item>
          <v-card-text class="pa-4">
            <v-layout row wrap class="mb-4 align-center">
              <v-flex xs12 sm5 class="pr-sm-2">
                <v-text-field
                  v-model="searchBase"
                  append-icon="mdi-magnify"
                  :label="$t('Buscar')"
                  single-line
                  hide-details
                  outlined
                  dense
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm3 class="px-sm-2 pt-2 pt-sm-0">
                <v-select
                  v-model="filterBaseType"
                  :items="filterOptions"
                  :label="$t('activity_type')"
                  outlined
                  dense
                  hide-details
                ></v-select>
              </v-flex>
              <v-flex xs12 sm4 class="text-right pl-sm-2 pt-4 pt-sm-0">
                <v-btn color="success" class="rounded-pill" @click="openDialogBase()">
                  <v-icon left>mdi-plus</v-icon>
                  {{ $t('agregar') }}
                </v-btn>
              </v-flex>
            </v-layout>

            <v-data-table
              :headers="headersBase"
              :items="filteredBaseActivities"
              :loading="loadingBase"
              :search="searchBase"
              class="elevation-1 custom-table"
              :no-data-text="$t('no_resultados')"
            >
              <template v-slot:item.activity_type="{ item }">
                <v-chip :color="item.workshop ? 'success' : 'info'" dark x-small label>
                  {{ item.workshop ? $t('workshop') : $t('sport') }}
                </v-chip>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editBaseActivity(item)">
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon color="error" @click="confirmDelete('base', item)">
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-tab-item>

        <!-- TAB 2: ACTIVIDADES EXTRACURRICULARES -->
        <v-tab-item>
          <v-card-text class="pa-4">
            <v-layout row wrap class="mb-4 align-center">
              <v-flex xs12 sm5 class="pr-sm-2">
                <v-text-field
                  v-model="searchExtra"
                  append-icon="mdi-magnify"
                  :label="$t('Buscar')"
                  single-line
                  hide-details
                  outlined
                  dense
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm3 class="px-sm-2 pt-2 pt-sm-0">
                <v-select
                  v-model="filterExtraType"
                  :items="filterOptions"
                  :label="$t('activity_type')"
                  outlined
                  dense
                  hide-details
                ></v-select>
              </v-flex>
              <v-flex xs12 sm4 class="text-right pl-sm-2 pt-4 pt-sm-0">
                <v-btn color="secondary" class="rounded-pill" @click="openDialogExtra()">
                  <v-icon left>mdi-plus</v-icon>
                  {{ $t('agregar') }}
                </v-btn>
              </v-flex>
            </v-layout>

            <v-data-table
              :headers="headersExtra"
              :items="filteredExtraActivities"
              :loading="loadingExtra"
              :search="searchExtra"
              class="elevation-1 custom-table"
              :no-data-text="$t('no_resultados')"
            >
              <template v-slot:item.idActivity="{ item }">
                {{ getBaseActivityName(item.idActivity) }}
              </template>
              <template v-slot:item.activity_type="{ item }">
                <v-chip
                  v-if="item.idActivity"
                  :color="getBaseActivityType(item.idActivity) === $t('workshop') ? 'success' : 'info'"
                  dark
                  x-small
                  label
                >
                  {{ getBaseActivityType(item.idActivity) }}
                </v-chip>
                <span v-else>N/A</span>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon color="secondary" v-bind="attrs" v-on="on" @click="manageSchedules(item)">
                      <v-icon small>mdi-calendar-clock</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t('schedules') }}</span>
                </v-tooltip>
                <v-btn icon color="primary" @click="editExtraActivity(item)">
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon color="error" @click="confirmDelete('extra', item)">
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <!-- DIALOG BASE ACTIVITY -->
    <v-dialog v-model="dialogBase" max-width="500px" persistent>
      <v-card class="rounded-lg">
        <v-toolbar color="primary" dark flat>
          <v-toolbar-title>{{ editedBaseIndex === -1 ? $t('agregar') : $t('modificar') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeBase">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-6">
          <v-form ref="formBase">
            <v-text-field
              v-model="editedBase.name"
              :label="$t('nombre')"
              outlined
              dense
              :rules="[
                v => !!v || $t('required'),
                v => !baseActivities.some(a => a.name.toLowerCase().trim() === (v || '').toLowerCase().trim() && a.idActivity !== editedBase.idActivity) || $t('msg_duplicate_name')
              ]"
            ></v-text-field>
            
            <p class="mb-2 font-weight-bold">{{ $t('activity_type') }}:</p>
            <v-radio-group v-model="activityType" row :rules="[v => !!v || $t('required')]">
              <v-radio :label="$t('workshop')" value="workshop" color="success"></v-radio>
              <v-radio :label="$t('sport')" value="sport" color="info"></v-radio>
            </v-radio-group>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn text @click="closeBase">{{ $t('cerrar') }}</v-btn>
          <v-btn color="primary" class="px-6 rounded-pill" @click="saveBase" :loading="savingBase">
            {{ $t('guardar') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG EXTRA ACTIVITY -->
    <v-dialog v-model="dialogExtra" max-width="500px" persistent>
      <v-card class="rounded-lg">
        <v-toolbar color="secondary" dark flat>
          <v-toolbar-title>{{ editedExtraIndex === -1 ? $t('agregar') : $t('modificar') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeExtra">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-6">
          <v-form ref="formExtra">
            <v-text-field
              v-model="editedExtra.name"
              :label="$t('nombre')"
              outlined
              dense
              class="mb-4"
              :rules="[
                v => !!v || $t('required'),
                v => !extraActivities.some(a => a.name.toLowerCase().trim() === (v || '').toLowerCase().trim() && a.idExtracurricularActivity !== editedExtra.idExtracurricularActivity) || $t('msg_duplicate_name')
              ]"
            ></v-text-field>
            
            <v-autocomplete
              v-model="editedExtra.idActivity"
              :items="groupedBaseActivities"
              item-text="name"
              item-value="idActivity"
              :label="$t('associated_base_activity')"
              outlined
              dense
              :rules="[v => !!v || $t('required')]"
              :no-data-text="$t('no_resultados')"
            ></v-autocomplete>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn text @click="closeExtra">{{ $t('cerrar') }}</v-btn>
          <v-btn color="secondary" class="px-6 rounded-pill" @click="saveExtra" :loading="savingExtra">
            {{ $t('guardar') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG SCHEDULES -->
    <v-dialog v-model="dialogSchedules" max-width="800px" scrollable>
      <v-card class="rounded-lg">
        <v-toolbar color="secondary" dark flat>
          <v-toolbar-title>{{ $t('schedules') }}: {{ selectedActivity ? selectedActivity.name : '' }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="success" class="rounded-pill mr-2" @click="openDialogSchedule()">
            <v-icon left>mdi-plus</v-icon>
            {{ $t('agregar') }}
          </v-btn>
          <v-btn icon @click="dialogSchedules = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pa-4 pt-6">
          <v-data-table
            :headers="headersSchedules"
            :items="schedules"
            :loading="loadingSchedules"
            class="elevation-1 border-radius-small"
            hide-default-footer
            :no-data-text="$t('no_registros')"
          >
            <template v-slot:item.dayWeek="{ item }">
              {{ getDayName(item.dayWeek) }}
            </template>
            <template v-slot:item.time_range="{ item }">
              <v-icon small left>mdi-clock-outline</v-icon>
              {{ item.starTime.substring(0, 5) }} - {{ item.endTime.substring(0, 5) }}
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn icon color="primary" @click="editSchedule(item)">
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
              <v-btn icon color="error" @click="confirmDelete('schedule', item)">
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogSchedules = false">{{ $t('cerrar') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG EDIT SCHEDULE -->
    <v-dialog v-model="dialogEditSchedule" max-width="400px" persistent>
      <v-card class="rounded-lg">
        <v-toolbar color="secondary" dark flat dense>
          <v-toolbar-title>{{ editedScheduleIndex === -1 ? $t('agregar') : $t('modificar') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeSchedule">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-6">
          <v-form ref="formSchedule">
            <v-select
              v-model="editedSchedule.dayWeek"
              :items="days"
              item-text="name"
              item-value="value"
              :label="$t('day')"
              outlined
              dense
              :rules="[
                v => v !== null || $t('required'),
                v => !schedules.some(s => s.dayWeek === v && s.idExtracurricularActivitySchedule !== editedSchedule.idExtracurricularActivitySchedule) || $t('msg_duplicate_day')
              ]"
            ></v-select>
            <v-layout row wrap>
              <v-flex xs6 class="pr-2">
                <v-text-field 
                  v-model="editedSchedule.starTime" 
                  :label="$t('check_in_time')" 
                  type="time" 
                  outlined 
                  dense
                  :rules="[v => !!v || $t('required')]"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 class="pl-2">
                <v-text-field 
                  v-model="editedSchedule.endTime" 
                  :label="$t('check_out_time')" 
                  type="time" 
                  outlined 
                  dense
                  :rules="[v => !!v || $t('required')]"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn text @click="closeSchedule">{{ $t('cerrar') }}</v-btn>
          <v-btn color="secondary" class="px-6 rounded-pill" @click="saveSchedule" :loading="savingSchedule">
            {{ $t('guardar') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- CONFIRM DELETE -->
    <v-dialog v-model="dialogDelete" max-width="400px">
      <v-card class="rounded-lg">
        <v-card-title class="headline grey lighten-4">{{ $t('aviso') }}</v-card-title>
        <v-card-text class="pt-6">{{ deleteMessage }}</v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogDelete = false">{{ $t('cerrar') }}</v-btn>
          <v-btn color="error" class="rounded-pill px-4" @click="deleteItemConfirm" :loading="deletingItem">{{ $t('Si') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { HTTP } from '@/main.js'
import store from '@/store'
import { mapGetters } from 'vuex'

export default {
  name: 'ActivityManagement',
  data: () => ({
    activeTab: 0,
    searchBase: '',
    filterBaseType: null,
    searchExtra: '',
    filterExtraType: null,
    loadingBase: false,
    loadingExtra: false,
    baseActivities: [],
    extraActivities: [],
    
    // UI Helpers
    activityType: null,

    // Base Activity CRUD
    dialogBase: false,
    savingBase: false,
    editedBaseIndex: -1,
    editedBase: { idActivity: null, name: '', workshop: false, sport: false, idSchool: null },
    defaultBase: { idActivity: null, name: '', workshop: false, sport: false, idSchool: null },

    // Extra Activity CRUD
    dialogExtra: false,
    savingExtra: false,
    editedExtraIndex: -1,
    editedExtra: { idExtracurricularActivity: null, name: '', idActivity: null, idSchool: null },
    defaultExtra: { idExtracurricularActivity: null, name: '', idActivity: null, idSchool: null },

    // Schedules
    dialogSchedules: false,
    loadingSchedules: false,
    schedules: [],
    selectedActivity: null,
    dialogEditSchedule: false,
    savingSchedule: false,
    editedScheduleIndex: -1,
    editedSchedule: { idExtracurricularActivitySchedule: null, idExtracurricularActivity: null, dayWeek: 0, starTime: '14:00', endTime: '15:00' },
    defaultSchedule: { idExtracurricularActivitySchedule: null, idExtracurricularActivity: null, dayWeek: 0, starTime: '14:00', endTime: '15:00' },

    // Generic Delete
    dialogDelete: false,
    deletingItem: false,
    itemToDelete: null,
    deleteType: '', // 'base', 'extra', 'schedule'

    days: [
      { name: 'Lunes', value: 0 }, { name: 'Martes', value: 1 }, { name: 'Miércoles', value: 2 },
      { name: 'Jueves', value: 3 }, { name: 'Viernes', value: 4 }, { name: 'Sábado', value: 5 },
      { name: 'Domingo', value: 6 }
    ]
  }),

  computed: {
    ...mapGetters(['getProfile']),
    headersBase() {
      return [
        { text: this.$t('nombre'), value: 'name', align: 'start' },
        { text: this.$t('activity_type'), value: 'activity_type', align: 'center', sortable: false },
        { text: this.$t('acciones'), value: 'actions', sortable: false, align: 'end' }
      ]
    },
    headersExtra() {
      return [
        { text: this.$t('base_activities'), value: 'idActivity', align: 'start' },
        { text: this.$t('extracurricular_activities'), value: 'name', align: 'start' },
        { text: this.$t('activity_type'), value: 'activity_type', align: 'center', sortable: false },
        { text: this.$t('acciones'), value: 'actions', sortable: false, align: 'end' }
      ]
    },
    filteredBaseActivities() {
      if (!this.filterBaseType) return this.baseActivities
      return this.baseActivities.filter(a => {
        if (this.filterBaseType === 'workshop') return a.workshop
        if (this.filterBaseType === 'sport') return a.sport
        return true
      })
    },
    filterOptions() {
      return [
        { text: this.$t('no_filter'), value: null },
        { text: this.$t('workshop'), value: 'workshop' },
        { text: this.$t('sport'), value: 'sport' }
      ]
    },
    filteredExtraActivities() {
      if (!this.filterExtraType) return this.extraActivities
      return this.extraActivities.filter(extra => {
        const base = this.baseActivities.find(a => (a.id === extra.idActivity || a.pk === extra.idActivity || a.idActivity === extra.idActivity))
        if (!base) return false
        if (this.filterExtraType === 'workshop') return base.workshop
        if (this.filterExtraType === 'sport') return base.sport
        return true
      })
    },
    headersSchedules() {
      return [
        { text: this.$t('day'), value: 'dayWeek', align: 'start' },
        { text: this.$t('schedule'), value: 'time_range', align: 'center' },
        { text: this.$t('acciones'), value: 'actions', sortable: false, align: 'end' }
      ]
    },
    groupedBaseActivities() {
      const workshops = this.baseActivities.filter(a => a.workshop)
      const sports = this.baseActivities.filter(a => a.sport)
      
      const items = []
      
      if (workshops.length > 0) {
        items.push({ header: this.$t('workshop') })
        items.push(...workshops)
      }
      
      if (workshops.length > 0 && sports.length > 0) {
        items.push({ divider: true })
      }
      
      if (sports.length > 0) {
        items.push({ header: this.$t('sport') })
        items.push(...sports)
      }
      
      return items
    },
    deleteMessage() {
      if (this.deleteType === 'base') return this.$t('msg_delete_base_activity')
      if (this.deleteType === 'extra') return this.$t('msg_delete_extra_activity')
      if (this.deleteType === 'schedule') return this.$t('msg_delete_activity_schedule')
      return this.$t('msg_accion_deshacer')
    }
  },

  created() {
    this.getBaseActivities()
    this.getExtraActivities()
  },

  methods: {
    // ---- BASE ACTIVITIES ----
    getBaseActivities() {
      this.loadingBase = true
      HTTP.get('activities_by_school/', {
        headers: { 'authorization': 'Token ' + store.getters.getToken }
      }).then(res => {
        this.baseActivities = res.data
        this.loadingBase = false
      }).catch(() => { this.loadingBase = false })
    },
    getBaseActivityName(id) {
      if (!id) return 'N/A'
      // Try mapping id or pk
      const activity = this.baseActivities.find(a => (a.id === id || a.pk === id || a.idActivity === id))
      return activity ? activity.name : 'N/A'
    },
    getBaseActivityType(id) {
      if (!id) return 'N/A'
      const activity = this.baseActivities.find(a => (a.id === id || a.pk === id || a.idActivity === id))
      if (!activity) return 'N/A'
      return activity.workshop ? this.$t('workshop') : (activity.sport ? this.$t('sport') : 'N/A')
    },
    openDialogBase() {
      this.editedBaseIndex = -1
      this.editedBase = Object.assign({}, this.defaultBase)
      this.activityType = null
      this.editedBase.idSchool = this.getProfile.idSchool
      this.dialogBase = true
    },
    editBaseActivity(item) {
      this.editedBaseIndex = this.baseActivities.indexOf(item)
      this.editedBase = Object.assign({}, item)
      if (this.editedBase.workshop) this.activityType = 'workshop'
      else if (this.editedBase.sport) this.activityType = 'sport'
      else this.activityType = null
      this.dialogBase = true
    },
    closeBase() {
      this.dialogBase = false
      this.$nextTick(() => { this.editedBase = Object.assign({}, this.defaultBase); this.editedBaseIndex = -1; this.activityType = null })
    },
    saveBase() {
      if (!this.$refs.formBase.validate()) return
      
      // Mutual exclusivity
      this.editedBase.workshop = (this.activityType === 'workshop')
      this.editedBase.sport = (this.activityType === 'sport')

      this.savingBase = true
      const method = this.editedBaseIndex > -1 ? 'put' : 'post'
      const url = this.editedBaseIndex > -1 ? `activities/${this.editedBase.idActivity}/` : 'activities/'
      HTTP({
        method, url, data: this.editedBase,
        headers: { 'authorization': 'Token ' + store.getters.getToken }
      }).then(() => {
        this.showSnackbar(this.$t('change_item_success'), 'success')
        this.getBaseActivities()
        this.closeBase()
      }).finally(() => { this.savingBase = false })
    },

    // ---- EXTRA ACTIVITIES ----
    getExtraActivities() {
      this.loadingExtra = true
      HTTP.get('extracurricular_activities_by_school/', {
        headers: { 'authorization': 'Token ' + store.getters.getToken }
      }).then(res => {
        this.extraActivities = res.data
        this.loadingExtra = false
      }).catch(() => { this.loadingExtra = false })
    },
    openDialogExtra() {
      this.editedExtraIndex = -1
      this.editedExtra = Object.assign({}, this.defaultExtra)
      this.editedExtra.idSchool = this.getProfile.idSchool
      this.dialogExtra = true
    },
    editExtraActivity(item) {
      this.editedExtraIndex = this.extraActivities.indexOf(item)
      this.editedExtra = Object.assign({}, item)
      this.dialogExtra = true
    },
    closeExtra() {
      this.dialogExtra = false
      this.$nextTick(() => { this.editedExtra = Object.assign({}, this.defaultExtra); this.editedExtraIndex = -1 })
    },
    saveExtra() {
      if (!this.$refs.formExtra.validate()) return

      this.savingExtra = true
      const method = this.editedExtraIndex > -1 ? 'put' : 'post'
      const url = this.editedExtraIndex > -1 ? `extracurricular_activities/${this.editedExtra.idExtracurricularActivity}/` : 'extracurricular_activities/'
      HTTP({
        method, url, data: this.editedExtra,
        headers: { 'authorization': 'Token ' + store.getters.getToken }
      }).then(() => {
        this.showSnackbar(this.$t('change_item_success'), 'success')
        this.getExtraActivities()
        this.closeExtra()
      }).finally(() => { this.savingExtra = false })
    },

    // ---- SCHEDULES ----
    manageSchedules(activity) {
      this.selectedActivity = activity
      this.getSchedules(activity.idExtracurricularActivity)
      this.dialogSchedules = true
    },
    getSchedules(activityId) {
      this.loadingSchedules = true
      HTTP.get(`extracurricular_activity_schedules_by_activity/${activityId}/`, {
        headers: { 'authorization': 'Token ' + store.getters.getToken }
      }).then(res => {
        this.schedules = res.data
        this.loadingSchedules = false
      }).catch(() => { this.loadingSchedules = false })
    },
    openDialogSchedule() {
      this.editedScheduleIndex = -1
      this.editedSchedule = Object.assign({}, this.defaultSchedule)
      this.editedSchedule.idExtracurricularActivity = this.selectedActivity.idExtracurricularActivity
      this.dialogEditSchedule = true
    },
    editSchedule(item) {
      this.editedScheduleIndex = this.schedules.indexOf(item)
      this.editedSchedule = Object.assign({}, item)
      this.dialogEditSchedule = true
    },
    closeSchedule() {
      this.dialogEditSchedule = false
      this.$nextTick(() => { this.editedSchedule = Object.assign({}, this.defaultSchedule); this.editedScheduleIndex = -1 })
    },
    saveSchedule() {
      if (!this.$refs.formSchedule.validate()) return

      this.savingSchedule = true
      const method = this.editedScheduleIndex > -1 ? 'put' : 'post'
      const url = this.editedScheduleIndex > -1 ? `extracurricular_activity_schedules/${this.editedSchedule.idExtracurricularActivitySchedule}/` : 'extracurricular_activity_schedules/'
      HTTP({
        method, url, data: this.editedSchedule,
        headers: { 'authorization': 'Token ' + store.getters.getToken }
      }).then(() => {
        this.showSnackbar(this.$t('change_item_success'), 'success')
        this.getSchedules(this.selectedActivity.idExtracurricularActivity)
        this.closeSchedule()
      }).finally(() => { this.savingSchedule = false })
    },

    // ---- DELETE ----
    confirmDelete(type, item) {
      this.deleteType = type
      this.itemToDelete = item
      this.dialogDelete = true
    },
    deleteItemConfirm() {
      this.deletingItem = true
      let url = ''
      if (this.deleteType === 'base') url = `activities/${this.itemToDelete.idActivity}/`
      else if (this.deleteType === 'extra') url = `extracurricular_activities/${this.itemToDelete.idExtracurricularActivity}/`
      else if (this.deleteType === 'schedule') url = `extracurricular_activity_schedules/${this.itemToDelete.idExtracurricularActivitySchedule}/`
      
      HTTP.delete(url, {
        headers: { 'authorization': 'Token ' + store.getters.getToken }
      }).then(() => {
        this.showSnackbar(this.$t('change_item_success'), 'success')
        if (this.deleteType === 'base') this.getBaseActivities()
        else if (this.deleteType === 'extra') this.getExtraActivities()
        else if (this.deleteType === 'schedule') this.getSchedules(this.selectedActivity.idExtracurricularActivity)
        this.dialogDelete = false
      }).finally(() => { this.deletingItem = false })
    },

    getDayName(value) {
      const dayWeek = this.days.find(d => d.value === value)
      return dayWeek ? dayWeek.name : ''
    },
    showSnackbar(message, color) {
      this.$store.commit('snackbar_change_message', message)
      this.$store.commit('snackbar_change_color', color)
      this.$store.commit('snackbar_activate_true')
    }
  }
}
</script>

<style scoped>
.custom-table >>> thead th {
  background-color: #f5f5f5 !important;
  color: #333 !important;
  font-weight: 600 !important;
}
</style>
